__turbopack_context__.v({
  "background": "CollectionSectionCZ-module__-VfMcq__background" + " " + __turbopack_context__.i(13628)["background"],
  "items": "CollectionSectionCZ-module__-VfMcq__items" + " " + __turbopack_context__.i(13628)["items"],
  "title": "CollectionSectionCZ-module__-VfMcq__title" + " " + __turbopack_context__.i(13628)["title"],
});
